import DrugsAccordionHeaderContent from "./DrugsAccordionHeaderContent";
import DrugsAccordionBodyContent from "./DrugsAccordionBodyContent";
import { Accordion } from "react-bootstrap";
import React from "react";
import { useAccordionButton, AccordionContext } from "react-bootstrap";
import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const AccordionToggleIcon = ({ eventKey }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const isOpen = activeEventKey === eventKey;
  const toggle = useAccordionButton(eventKey);

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation(); // avoids conflicts with inner buttons
        toggle(e);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle(e);
        }
      }}
      className="drugs-accordion-toggle"
      style={{ cursor: "pointer" }}
    >
      <FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} />
    </span>
  );
}

const CustomHeader = ({ eventKey, className = "", children }) =>  {
  const toggle = useAccordionButton(eventKey);

  const onKeyDown = (e) => { // for accessibility
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle(e);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={className}
      onClick={toggle}
      onKeyDown={onKeyDown}
    >
      {children}
    </div>
  );
}

const DrugsAccordion = ({sortedPatDrugs, printView, onDeleteDrug}) => {
  return(
    <Accordion className={ printView ? "drugs-accordion" : "drugs-accordion drugs-accordion-compact" }>
      { sortedPatDrugs?.map((drug, i) => {
        const eventKey = `${drug?.id ?? drug?.productName ?? "drug"}-${i}`;

        return printView ? (
          <div
            className="w3-column w3-round-large w3-margin w3-padding-small w3-border w3-border-blue drugs-accordion-item-print"
            key={ `drug${ i }` }
          >
            <DrugsAccordionHeaderContent drug={ drug } onDeleteDrug={ onDeleteDrug } patDrugs={ sortedPatDrugs } />
            <div className="w3-row">
              <DrugsAccordionBodyContent drug={drug}  printView={printView}/>
            </div>
          </div>
        ) : (
          <Accordion.Item
            eventKey={eventKey}
            key={eventKey}
            className="drugs-accordion-item drugs-accordion-item-compact"
          >
            {/* replaces original Accordion.Header */}
            <CustomHeader
              eventKey={eventKey}
              className={printView ? null : "w3-row w3-container accordion-header-row drugs-accordion-header "}
            >
              <div
                className={`w3-col s12 drugs-accordion-header-content ${drug?.status !== "active" && "drug_discontinued w3-border w3-round-large"}`}
                onClick={ (e) => e.stopPropagation() }
                onKeyDown={(e) => e.stopPropagation()}
              >
                <DrugsAccordionHeaderContent
                  drug={drug}
                  onDeleteDrug={onDeleteDrug}
                  patDrugs={sortedPatDrugs}
                  toggleControl={<AccordionToggleIcon eventKey={eventKey} />}
                />
              </div>
            </CustomHeader>
            <Accordion.Body className="w3-container drugs-accordion-body">
              <DrugsAccordionBodyContent drug={drug}  printView={printView} />
            </Accordion.Body>
          </Accordion.Item>
        );
      }) }
    </Accordion>
  );
}

export default DrugsAccordion;